import { validarSintaxis } from './validarSintaxis'
import { generarExpresionBase } from './generarExpresionBase'
import { normalizaAlias, resolverAliasDentroDeExpresion } from './normalizaAlias'

/**
 * Normaliza todos los placeholders detectados y devuelve:
 * - lista normalizada
 * - errores detectados
 * - mapa expresiones finales por tag original
 */
export function normalizarPlaceholders(placeholders, variables, expresiones) {
  const { aliasToVariable, aliasToExpresion } = normalizaAlias(variables, expresiones)

  const resultados = []
  const errores = []
  const mapaFinal = {} // tagOriginal → expresionFinal

  for (const ph of placeholders) {
    const tag = ph.tag
    const contenido = ph.contenido.trim()

    // Validación inicial de sintaxis
    const sint = validarSintaxis(tag)
    if (!sint.ok) {
      errores.push({ tag, error: sint.error })
      mapaFinal[tag] = tag // conservar placeholder erróneo
      continue
    }

    // 1️⃣ Si ya es un path interno v: o i: → respetar
    if (/^(v:|i:)/.test(contenido)) {
      mapaFinal[tag] = tag
      resultados.push({ original: tag, normalizado: tag, tipo: 'directo' })
      continue
    }

    // 2️⃣ Si coincide con alias de variable
    if (aliasToVariable[contenido]) {
      const variable = aliasToVariable[contenido]
      const expresion = variable.expresion || generarExpresionBase(variable)

      mapaFinal[tag] = expresion
      resultados.push({ original: tag, normalizado: expresion, tipo: 'variable' })
      continue
    }

    // 3️⃣ Si coincide con alias de expresión
    if (aliasToExpresion[contenido]) {
      const exp = aliasToExpresion[contenido].expresion
      const expExpandida = resolverAliasDentroDeExpresion(
        exp,
        aliasToVariable,
        aliasToExpresion
      )

      mapaFinal[tag] = expExpandida
      resultados.push({ original: tag, normalizado: expExpandida, tipo: 'expresion' })
      continue
    }

    // 4️⃣ Si parece función, debe resolverse recursivamente
    if (/^[a-zA-Z0-9_]+:/.test(contenido)) {
      // Expandir alias dentro de la expresión completa
      const expresionExpandida = resolverAliasDentroDeExpresion(
        tag,
        aliasToVariable,
        aliasToExpresion
      )

      mapaFinal[tag] = expresionExpandida

      resultados.push({
        original: tag,
        normalizado: expresionExpandida,
        tipo: 'funcion',
      })

      continue
    }

    // ❌ No coincide con nada → error
    errores.push({ tag, error: 'Alias no encontrado en variables ni expresiones' })
    mapaFinal[tag] = tag
  }

  return {
    resultados,
    errores,
    mapaFinal,
  }
}
